// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__0qOjK","source":"Description_source__st9vP"};